type TranslationsData = Record<string, any>;

export const T_Translations = Symbol('Translations');

export class Translations {
  public isLoaded: boolean = false;

  private _translations: TranslationsData = {};
  private _translationsPromise: Promise<Record<string, any>>;

  constructor(
    private resourcePath: string,
    private defaultResourcePath?: string
  ) {
    if (!this.resourcePath) {
      throw new Error('Translations requires  resourcePath!');
    }

    this.loadData();
  }

  public get data(): TranslationsData {
    return this._translations;
  }

  public get dataPromise(): Promise<TranslationsData> {
    return this._translationsPromise;
  }

  public get(key: string, rollback: string = ''): any {
    return this._translations[key] || rollback;
  }

  public getAsync(key: string): Promise<any> {
    return this._translationsPromise.then((translations) => translations[key] || '');
  }

  private loadData(): void {
    this._translationsPromise = this.fetchTranslations(this.getFilePath())
      .catch(() => {
        // If primary translation fails, try to load the original/default
        const originalPath = this.getOriginalFilePath();
        if (originalPath && originalPath !== this.getFilePath()) {
          return this.fetchTranslations(originalPath);
        }
        return {};
      })
      .catch(() => ({})); // Final fallback to empty object

    this._translationsPromise.then((translations) => {
      this._translations = translations;
      this.isLoaded = true;
    });
  }

  private fetchTranslations(filePath: string): Promise<TranslationsData> {
    return fetch(filePath).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Failed to load translations from ${filePath}`);
    });
  }

  private getFilePath(): string {
    return `${this.resourcePath}`;
  }

  private getOriginalFilePath(): string {
    // Use explicit default path if provided
    if (this.defaultResourcePath) {
      return this.defaultResourcePath;
    }

    const originalPath = this.resourcePath
      .replace(/[-_][a-z]{2}(\.|$)/i, '-en$1') // Replace -xx or _xx with -en
      .replace(/[-_]en(\.|$)/i, '$1');

    return originalPath;
  }
}
